import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';

import { PeriodFilterComponent } from './period-filter/period-filter.component';

/** Seletor de período (presets + intervalo), compartilhado entre Smart Review e Gestão de usuários. */
@NgModule({
  declarations: [PeriodFilterComponent],
  imports: [CommonModule, FormsModule, PoModule],
  exports: [PeriodFilterComponent]
})
export class PeriodFilterModule {}
